import {Component, OnInit, inject} from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {TabBarService} from '../../_services/gui/tab-bar.service';
import {I18nService} from '../../_services/gui/i18n.service';
import {GuidesService} from '../../_services/data/guides.service';
import {first} from 'rxjs/operators';
import {GuiPermissionsService} from '../../_services/gui/gui-permissions.service';
import {NgClass} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-tab-bar',
    templateUrl: './tab-bar.component.html',
    styleUrls: ['./tab-bar.component.scss'],
    imports: [RouterLink, NgClass, TranslateModule]
})
export class TabBarComponent implements OnInit {

  guideKey: string;
  guideName: string;

  displayTabBar: boolean = false;

  canViewAdmin: boolean = false;
  canViewBusiness: boolean = false;
  canViewConsumer: boolean = false;

  private router = inject(Router);
  private tabBarService = inject(TabBarService);
  private i18nService = inject(I18nService);
  private readonly guiPermissionsService = inject(GuiPermissionsService);
  private guidesService = inject(GuidesService);

  constructor() {
    this.tabBarService.display.subscribe((d: boolean) => {
      this.displayTabBar = d;
    });

    this.tabBarService.guideLink.subscribe(g => {
      if(g) {
        this.guideKey = g;
        this.i18nService.getTranslation(`guides.${g}.name`).subscribe(t => this.guideName = t);
      } else {
        this.guideName = null;
      }
    });

    this.guiPermissionsService.canViewAdmin$.subscribe(v => this.canViewAdmin = v);
    this.guiPermissionsService.canViewBusiness$.subscribe(v => this.canViewBusiness = v);
    this.guiPermissionsService.canViewConsumer$.subscribe(v => this.canViewConsumer = v);

  }

  ngOnInit() { }

  isActive(url: string): boolean {
    return this.router.isActive(url, false);
  }

  displayGuide(guideKey: string) {
    const guideNameParam = guideKey.trim().toLowerCase();
    if(guideNameParam === 'user' || guideNameParam === 'admin') {
      this.guidesService.getGuide(guideNameParam).pipe(first()).subscribe((data: ArrayBuffer) => {
        const blob = new Blob([data], {type: 'application/pdf'});

        // IE 11 doesn't open PDF Blobs so if it's IE 11 offer to save or open.
        if((window.navigator as any)?.msSaveOrOpenBlob) {
          (window.navigator as any).msSaveOrOpenBlob(blob);
        } else {
          window.open(URL.createObjectURL(blob), '_blank');
        }
      });
    }
  }
}
